import React from "react";
import {Dropdown, DropdownButton} from "react-bootstrap";

function DropdownDevice(props: { device: string, setDevice: any}) {
  const {device, setDevice} = props;
  const devices = ['Meta Quest', 'PCVR'];
  const items = devices.map((s: string) => {
      return (
        <Dropdown.Item key={`dropdown-device-${s}`} onClick={() => setDevice(s)}>
          {s}
        </Dropdown.Item>
      );
    }
  );

  return (
    <Dropdown onClick={(e: any)=> e.stopPropagation()}>
      <DropdownButton key="dropdown-button device" variant="primary" menuAlign="left" title={device}>
        {items}
      </DropdownButton>
    </Dropdown>
  );
}

export default DropdownDevice;
